import { render } from "./TicketPopup.vue?vue&type=template&id=09985818&scoped=true"
import script from "./TicketPopup.vue?vue&type=script&lang=js"
export * from "./TicketPopup.vue?vue&type=script&lang=js"

import "@/assets/css/components/ticketPopup.css?vue&type=style&index=0&id=09985818&scoped=true&lang=css"

import exportComponent from "C:\\DEVER\\meta-buysell.vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09985818"]])

export default __exports__